
import Button from '@/components/base/Button';

export default function ContactSection() {
  return (
    <section className="py-20 bg-pink-50">
      <div className="max-w-6xl mx-auto px-6">
        <div className="text-center mb-16 animate-fade-in-up">
          <h2 className="text-4xl lg:text-5xl font-bold text-black font-serif mb-6 animate-slide-down">
            Ready to Transform Your Look?
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto animate-fade-in delay-300">
            Book your consultation today and discover the confidence that comes with radiant, healthy skin.
          </p>
        </div>
        
        <div className="grid md:grid-cols-2 gap-12 items-center">
          <div className="animate-fade-in-left">
            <div className="space-y-6">
              <div className="flex items-center space-x-4 group transform hover:translate-x-2 transition-transform duration-300">
                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-md group-hover:shadow-lg transition-shadow duration-300">
                  <i className="ri-phone-line text-xl text-black"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-black">Phone</h3>
                  <p className="text-gray-600">(403) 454-8778</p>
                </div>
              </div>
              
              <div className="flex items-center space-x-4 group transform hover:translate-x-2 transition-transform duration-300">
                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-md group-hover:shadow-lg transition-shadow duration-300">
                  <i className="ri-map-pin-line text-xl text-black"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-black">Location</h3>
                  <p className="text-gray-600">Calgary, Alberta</p>
                </div>
              </div>
              
              <div className="flex items-center space-x-4 group transform hover:translate-x-2 transition-transform duration-300">
                <div className="w-12 h-12 bg-white rounded-full flex items-center justify-center shadow-md group-hover:shadow-lg transition-shadow duration-300">
                  <i className="ri-time-line text-xl text-black"></i>
                </div>
                <div>
                  <h3 className="font-semibold text-black">Hours</h3>
                  <p className="text-gray-600">Mon-Sat: 9AM-7PM</p>
                </div>
              </div>
            </div>
          </div>
          
          <div className="animate-fade-in-right">
            <div className="bg-white rounded-lg p-8 shadow-lg transform hover:scale-105 transition-all duration-500 hover:shadow-xl">
              <h3 className="text-2xl font-semibold text-black mb-6 font-serif animate-fade-in">
                Book Your Appointment
              </h3>
              <div className="space-y-6">
                <Button 
                  size="lg" 
                  href="tel:4034548778"
                  className="w-full transform hover:scale-105 transition-all duration-300 animate-pulse-subtle"
                >
                  <i className="ri-phone-line mr-2"></i>
                  Call Now - (403) 454-8778
                </Button>
                
                <div className="text-center">
                  <p className="text-gray-600 mb-4 animate-fade-in delay-300">
                    Or you can visit us for a consultation
                  </p>
                  <div className="flex justify-center space-x-4">
                    <a 
                      href="https://www.facebook.com/people/Forever-Young-Spa-Calgary/100043285724313/"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-8 h-8 bg-pink-100 rounded-full flex items-center justify-center transform hover:scale-110 transition-transform duration-300 cursor-pointer"
                    >
                      <i className="ri-facebook-fill text-black"></i>
                    </a>
                    <a 
                      href="https://www.instagram.com/foreveryoungcalgary/?hl=en"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-8 h-8 bg-pink-100 rounded-full flex items-center justify-center transform hover:scale-110 transition-transform duration-300 cursor-pointer"
                    >
                      <i className="ri-instagram-line text-black"></i>
                    </a>
                    <a 
                      href="https://share.google/hbkKfTEvgPutMnLJ0"
                      target="_blank"
                      rel="noopener noreferrer"
                      className="w-8 h-8 bg-pink-100 rounded-full flex items-center justify-center transform hover:scale-110 transition-transform duration-300 cursor-pointer"
                    >
                      <i className="ri-google-fill text-black"></i>
                    </a>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
